"use strict";
/*
 * Created on 29/01/2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * @author JMr
 */


var Localisation =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(Localisation, _DomainObject_1$Domai);

  /**
   * Constructs Localisation object.
   *
   * @param id
   * @param locale representation of an language  (eg. en,cs,de)
   * @param localisation localisation object with all keys for certain language
   */
  function Localisation(id, locale, localisation) {
    var _this;

    _classCallCheck(this, Localisation);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Localisation).call(this));
    _this.id = id;
    _this.locale = locale;
    _this.localisation = localisation;
    return _this;
  }

  return Localisation;
}(DomainObject_1.DomainObject);

exports.Localisation = Localisation;